/* EVENTS INVOLVING REGISTRATION */

export default {
  account_retrieval_error: {
    //after 5 times checking the account
    excludeSuperAdmin: true,
    getProps: () => {
      return {};
    },
  },
};
